<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="12">
            <el-form-item label="项目名称(英)" prop="nameCn"
                :rules="[
                  {required: true, message:'项目名称(英)不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写项目名称(英)"     ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目名称(中)" prop="">
              <span>{{ inputForm.project.name }}</span>
           </el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="项目编号" prop="specEn">
              {{ inputForm.project.proCode }}
           </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="" label="项目单价：">
              <span>$ {{ inputForm.price }} / {{ inputForm.project.unit.unitEn }}</span>
            </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="项目描述(英)" prop="introductionEn"
                :rules="[
                  {required: true, message:'项目描述(英)不能为空', trigger:'blur'}
                 ]">
              <el-input type="textarea" :autosize="{ minRows: 5}" v-model="inputForm.introductionEn" placeholder="请填写项目描述(英)" ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="项目描述(中)" prop="introductionCn"
                :rules="[
                 ]">
                 <el-input type="textarea" :autosize="{ minRows: 5}" v-model="inputForm.introductionCn" placeholder="请填写项目描述(中)"  ></el-input>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import cecUnmSetMealPositionProjectService from '@/api/cecunmsetmealpositionproject/cecUnmSetMealPositionProjectService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          introductionEn: '',
          introductionCn: '',
          nameCn: '',
          projectSetsId: '',
          projectVersionId: '',
          projectPositionId: '',
          storeyId: '',
          roomId: '',
          positionId: '',
          projectId: '',
          num: '',
          price: '',
          totalPrice: '',
          unitId: '',
          description: '',
          linkProjectId: '',
          makeupId: '',
          isSelected: '',
          project: {
            name: '',
            proCode: '',
            unit: {
              unitEn: ''
            }
          }
        }
      }
    },
    components: {
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建UM项目信息`
        } else if (method === 'edit') {
          this.title = '修改UM项目信息'
        } else if (method === 'view') {
          this.title = '查看UM项目信息'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmSetMealPositionProjectService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmSetMealPositionProjectService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
